import baseapi from "./../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const DashboardAPI = async (setTodayLeadCount, setTotalLeadCount, setWeekLeadCount, setMonthLeadCount, setDuplicateLeadCount, setLoading) =>
{
    setLoading(true);    

    try 
    {
        const response = await baseapi.get("/api/publisher/dashboard");

        //console.log("Data got successfully", response.data);
        
        setTodayLeadCount(response.data.leadcount.todaycount);
        setTotalLeadCount(response.data.leadcount.totalcount);
        setWeekLeadCount(response.data.leadcount.weekcount);
        setMonthLeadCount(response.data.leadcount.monthcount);
        setDuplicateLeadCount(response.data.leadcount.duplicatecount);
        

        setLoading(false);
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}

